import React, { useState } from "react";
// react component for creating dynamic tables
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
//import ReactBSAlert from "react-bootstrap-sweetalert";
import ToolkitProvider, {
  Search,
  CSVExport,
} from "react-bootstrap-table2-toolkit";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import KeyboardArrowDown from "@material-ui/icons/KeyboardArrowDown";
import OutlinedInput from "@material-ui/core/OutlinedInput";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import DatePicker from "react-datepicker";
// @material-ui/lab components
// @material-ui/icons components
// core components
import Snackbar from "components/Snackbar/Snackbar.js";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import btnComponentStyles from "assets/theme/components/button.js";
import LoadingAnimation from "components/Animations/loading";
import Slide from "@material-ui/core/Slide";
import { useAsyncEffect } from "use-async-effect";

import {
  getProSubscriptions,
} from "../../network/ApiAxios";
import { redirectToLogout,zeroFill,dateSortFunc,
 numericSortFunc
 } from "common/SharedFn";


const useStyles = makeStyles(componentStyles);
const useStylesButtons = makeStyles(btnComponentStyles);
const createHistory = require("history").createBrowserHistory;

const pagination = paginationFactory({
  page: 1,
  alwaysShowAllBtns: true,
  showTotal: true,
  withFirstAndLast: false,
  sizePerPage:50,
  sizePerPageRenderer: ({ onSizePerPageChange }) => (
    <div className="dataTables_length" id="datatable-basic_length">
      <label>
        Show{" "}
        {
          <select
            name="datatable-basic_length"
            aria-controls="datatable-basic"
            className="form-control form-control-sm"
            onChange={(e) => onSizePerPageChange(e.target.value)}
          >
            <option value="50">50</option>
            <option value="100">100</option>
            <option value="500">500</option>
            <option value="1000">1000</option>
          </select>
        }{" "}
        entries.
      </label>
    </div>
  ),
});

const { SearchBar } = Search;

const { ExportCSVButton } = CSVExport;

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ProSubscriptionsTable = (props) => {
  const classes = { ...useStyles(), ...useStylesButtons() };
  const [alert, setAlert] = React.useState(false);
  const componentRef = React.useRef(null);
  const [data, setData] = useState([]);
  const [statusList, setStatusList] = useState([]);
  const [isLoading, setIsLoading] = useState("");
  const [notifMessage, setNotifMessage] = useState("");
  const [success, setSuccess] = React.useState(false);
  const [showError, setShowError] = React.useState(false);
  const [activeOnly, setActiveOnly] = useState(1);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [asOfDate, setAsOfDate] = useState();
  const [asOfStartDate, setAsOfStartDate] = useState();
  const [id, setId] = useState();
  const [updateStatusModal, setUpdateStatusModal] = useState(false);
  const [executeStatusUpdate, setExecuteStatusUpdate] = useState(false);
  const [forceRefresh, setForceRefresh] = useState(false);
  const [newStatus, setNewStatus] = useState(1);
  const [ids, setIds] = useState([]);
  const [selectedCount, setSelectedCount] = useState(0);
  var days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];

  const selectRow = {
    mode: "checkbox",
    clickToSelect: true,
    style: { backgroundColor: "#c8e6c9" },
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        ids.push(row.id);
      } else {
        var index = ids.indexOf(row.id);
        if (index !== -1) {
          ids.splice(index, 1);
        }
      }
      setSelectedCount(ids.length);
    },
    onSelectAll: (isSelect, rows, e) => {
      if (isSelect) {
        for (var i = 0; i < rows.length; i++) {
          ids.push(rows[i].id);
        }
      } else {
        for (var i = 0; i < rows.length; i++) {
          var index = ids.indexOf(rows[i].id);
          if (index !== -1) {
            ids.splice(index, 1);
          }
        }
      }
      setSelectedCount(ids.length);
    },
  };

  const showSuccessNotification = (message) => {
    setNotifMessage(message);
    setSuccess(true);
    setTimeout(function () {
      setSuccess(false);
    }, 3000);
  };

  const showErrorNotification = (message) => {
    setNotifMessage(message);
    setShowError(true);
    setTimeout(function () {
      setShowError(false);
    }, 3000);
  };

  const clearCurrentRecord = () => {
    setNewStatus(1);
    setId();
  };

  const fetchProSubscriptions = async () => {
    setForceRefresh(false);
    setIsLoading(true);
    setData([]);
    try {
      const response = await getProSubscriptions(startDate, endDate,asOfStartDate,asOfDate,activeOnly);
      const { data } = response;
      // const responseStatusList = await getAllProSubscriptionStatus();
      if (data.result.isSuccess) {
        // setStatusList(responseStatusList.data.data);
        setData(data.data.map((prop) => makeTableRow(prop)));
        //setError("");
      } else {
        showErrorNotification(data.result.description);
        if (data.result.code == -2) {
          redirectToLogout();
        }
      }
    } catch (ex) {
      showErrorNotification("Failed to fetch pro subscriptions "+ex);
    }
    setIsLoading(false);
  };

  // const bulkUpdateStatusAction = async () => {
  //   setExecuteStatusUpdate(false);
  //   setIsLoading(true);
  //   try {
  //     const response = await bulkUpdateOrderStatus(ids, newStatus);
  //     const { data } = response;
  //     if (data.result.isSuccess) {
  //       showSuccessNotification("Status Updated Successfully");
  //       setUpdateStatusModal(false);
  //       setForceRefresh(true);
  //     } else {
  //       showErrorNotification(data.result.description);
  //       setIsLoading(false);
  //     }
  //   } catch (ex) {
  //     showErrorNotification("Failed to update status");
  //     setIsLoading(false);
  //   }
  // };

  useAsyncEffect(async () => {
    if (endDate == null) {
      var endDateStored = localStorage.getItem("searchEndDate");
      if(endDateStored != null && endDateStored.toUpperCase() !== "NULL"){
        setEndDate(new Date(endDateStored));
      }
      else{
        setEndDate(new Date());
      }
    }
    if (asOfStartDate == null) {
      var asOfStartDateStored = localStorage.getItem("searchAsOfStartDate");
      if(asOfStartDateStored != null && asOfStartDateStored.toUpperCase() !== "NULL"){
        setAsOfStartDate(new Date(asOfStartDateStored));
      }
      else{
        setAsOfStartDate(new Date());
      }
    }
    if (asOfDate == null) {
      var asOfDateStored = localStorage.getItem("searchAsOfDate");
      if(asOfDateStored != null && asOfDateStored.toUpperCase() !== "NULL"){
        setAsOfDate(new Date(asOfDateStored));
      }
      else{
        setAsOfDate(new Date());
      }
    }
    if (startDate == null) {
      var startDateStored = localStorage.getItem("searchStartDate");
      if(startDateStored != null && startDateStored.toUpperCase() !== "NULL"){
        setStartDate(new Date(startDateStored));
      }
      else{
        setStartDate(new Date().setDate(new Date().getDate() - 7));
      }
    }
    // if (activeOnly == null) {
      var searchActiveOnly = localStorage.getItem("searchActiveOnly");
      if(searchActiveOnly != null){
        setActiveOnly(searchActiveOnly);
      }
    //   else{
    //     setActiveOnly(1);
    //   }
    // }
      if (startDate != null && endDate != null  && activeOnly != null && asOfDate != null && asOfStartDate != null) {
        fetchProSubscriptions();
      }
  }, [
    forceRefresh,
    executeStatusUpdate,
    startDate,
    endDate,
    asOfDate,
    asOfStartDate,
    activeOnly
  ]);

  const makeTableRow = (info) => {
    return {
      ...info,
      idForm: (
        "PS"+zeroFill(info.id,5)
      ),
      userIdForm: (
        "C"+zeroFill(info.userId,5)
      ),
      packageIdForm: (
        "PR"+zeroFill(info.packageId,5)
      ),
      username: info.userFirstName + " " + info.userLastName,
      autoRenewText: info.autoRenew === 1 ? "Yes" : "No",
      tenorText: info.tenor === 1 ? "Monthly" : info.tenor === 7 ? "Weekly" : "Annually",
      priceWithoutDiscountAndVat: info.priceWithoutDiscountAndVat.toFixed(3),
      proSavings: info.userSavings.toFixed(3),
      proCost: info.userProCost.toFixed(3),
      totalOrderPrice: info.totalOrderPrice.toFixed(3),
      totalDiscountedOrderPrice: info.totalDiscountedOrderPrice.toFixed(3),
      accruedAmountText: info.accruedAmount.toFixed(3),
      monthRateText: info.monthRate.toFixed(3),
      feeRounded: info.fee.toFixed(3),
      feeVatRounded: info.feeVat.toFixed(3),
      feeWithVatRounded: info.feeWithVat.toFixed(3),
      net: info.net.toFixed(3)
    };
  };

  return (
    <>
      {alert}
      {/* Page content */}
      <Container
        maxWidth={false}
        component={Box}
        marginTop="-4.5rem"
        classes={{ root: classes.containerRoot }}
      >
        <Grid container>
          <Grid item xs={12}>
            <Card elevation={0}>
              <CardHeader
                subheader={
                  <>
                    <Box
                      component={Typography}
                      variant="h2"
                      marginBottom="0!important"
                    >
                      <Box component="span">Pro Subscriptions</Box>
                    </Box>
                  </>
                }
                classes={{ root: classes.cardHeaderRoot }}
              ></CardHeader>

              <ToolkitProvider
                data={data}
                keyField="id"
                columns={[
                  {
                    dataField: "idForm",
                    text: "ID",
                    sort: true,
                  },
                  {
                    dataField: "username",
                    text: "User Name",
                    sort: true,
                  },
                  {
                    dataField: "userIdForm",
                    text: "User ID",
                    sort: true,
                  },
                  {
                    dataField: "userMobile",
                    text: "Mobile Number",
                    sort: true,
                  },
                  {
                    dataField: "onDatetime",
                    text: "Placed On",
                    sort: true, 
                    sortFunc: dateSortFunc,                    
                  },
                  {
                    dataField: "packageIdForm",
                    text: "Package ID",
                    sort: true,
                  },
                  {
                    dataField: "packageName",
                    text: "Package Name",
                    sort: true,
                  },
                  {
                    dataField: "tenorText",
                    text: "Tenor",
                    sort: true,
                  },
                  {
                    dataField: "recordStartDateFormatted",
                    text: "Start Date",
                    sort: true,
                    sortFunc: dateSortFunc 
                  },
                  {
                    dataField: "endDateFormatted",
                    text: "End Date",
                    sort: true,
                    sortFunc: dateSortFunc
                  },
                  {
                    dataField: "accruedAmountText",
                    text: "Accrued Amount",
                    sort: true,
                    sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "accruedDays",
                    text: "Accrued Days",
                    sort: true,
                    sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "monthRate",
                    text: "Month Rate",
                    sort: true,
                    sortFunc: numericSortFunc,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "price",
                    text: "Price with VAT",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "proCost",
                    text: "Total Pro Cost",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "proSavings",
                    text: "Total Pro Savings",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "totalOrderPrice",
                    text: "Total Order Price",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "totalDiscountedOrderPrice",
                    text: "Total Discounted Order Price",
                    sort: true,
                    sortFunc: numericSortFunc,
                  },
                  {
                    dataField: "vat",
                    text: "VAT Order",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "priceWithoutDiscountAndVat",
                    text: "Price",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  }, 
                  {
                    dataField: "feeRounded",
                    text: "PG Fees",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "feeVatRounded",
                    text: "PG Fees VAT",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "feeWithVatRounded",
                    text: "PG Fees With VAT",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "net",
                    text: "Net",
                    sort: true,
                    headerStyle: {display : "none"},
                    style : {display : "none"}
                  },
                  {
                    dataField: "paymentMethodName",
                    text: "Payment Method",
                    sort: true,
                  },
                  {
                    dataField: "autoRenewText",
                    text: "Is Auto Renew",
                    sort: true,
                  },
                  {
                    dataField: "status",
                    text: "Status",
                    sort: true,
                  }
                ]}
                search
                exportCSV
              >
                {(props) => (
                  <div className="py-4 table-responsive">
                    <Grid container className="pl-4">
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        style={{ marginBottom: "15px" }}
                      >
                        {/* <Tooltip
                          title="This will copy to your download the table content."
                          style={{ margin: "5px" }}
                        > */}
                        <ExportCSVButton
                          className="MuiButtonBase-root MuiButton-root MuiButton-contained MuiButton-containedSizeSmall MuiButton-sizeSmall"
                          {...props.csvProps}
                        >
                          <span className="MuiButton-label">Download</span>
                        </ExportCSVButton>
                        <Button style={{ display: "none" }}></Button>
                        {/* </Tooltip> */}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <div
                          id="datatable-basic_filter"
                          className="dataTables_filter px-4 pb-1 float-right"
                        >
                          <label>
                            Search:
                            <SearchBar
                              className="form-control-sm"
                              placeholder=""
                              {...props.searchProps}
                            />
                          </label>
                        </div>
                      </Grid>
                    </Grid>

                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <form>
                          View by Placed On From &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="Start Date"
                              selected={startDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                                localStorage.setItem("searchStartDate", date);
                                setStartDate(date);}}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>{" "}
                          &emsp; to &emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="End Date"
                              selected={endDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchEndDate", date);
                                setEndDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                           &emsp;
                          <div
                            style={{
                              display: "inline-block",
                              marginBottom: "20px",
                            }}
                          >
                            <Select
                              variant="outlined"
                              value={activeOnly}
                              onChange={(e) => {
                                localStorage.setItem("searchActiveOnly", e.target.value);
                                setActiveOnly(e.target.value);}}
                              IconComponent={KeyboardArrowDown}
                            >
                              <MenuItem value={1}>Active Only</MenuItem>
                              <MenuItem value={0}>All</MenuItem>
                            </Select>
                          </div>&emsp; as of from&emsp;<div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="As of Start Date"
                              selected={asOfStartDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchAsOfStartDate", date);
                                setAsOfStartDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                           &emsp;to&emsp;
                          <div style={{ display: "inline-block" }}>
                            <DatePicker
                              timeCaption="As of Date"
                              selected={asOfDate}
                              customInput={<OutlinedInput />}
                              onChange={(date) => {
                              localStorage.setItem("searchAsOfDate", date);
                                setAsOfDate(date);
                              }}
                              dateFormat="dd-MM-yyyy"
                            />
                          </div>
                           &emsp;{" "}
                        </form>
                      </Grid>
                    </Grid>
                    <Grid container className="pl-4">
                      <Grid item xs={12} sm={12}>
                        <div
                            style={{
                              marginBottom: "20px",
                            }}
                          >
                        {selectedCount} Pro Subscriptions Selected
                        </div>
                      </Grid>
                    </Grid>
                    <BootstrapTable
                      ref={componentRef}
                      {...props.baseProps}
                      bootstrap4={true}
                      pagination={pagination}
                      bordered={true}
                      striped={true}
                      selectRow={selectRow}
                      noDataIndication={() =>
                        isLoading ? (
                          <Box
                            component={Grid}
                            container
                            justifyContent="center"
                            className="justify-content-center"
                          >
                            <div
                              className="text-center"
                              style={{ width: "20%" }}
                            >
                              <LoadingAnimation />{" "}
                            </div>
                          </Box>
                        ) : (
                          <h4>No Records</h4>
                        )
                      }
                      id="main-table"
                    />
                  </div>
                )}
              </ToolkitProvider>
            </Card>
          </Grid>
        </Grid>
        <Snackbar
          place="tr"
          color="success"
          // icon={AddAlert}
          message={notifMessage}
          open={success}
          closeNotification={() => setSuccess(false)}
          close
        />

        <Snackbar
          place="tr"
          color="rose"
          // icon={AddAlert}
          message={notifMessage}
          open={showError}
          closeNotification={() => setShowError(false)}
          close
        />
      </Container>
    </>
  );
};

export default ProSubscriptionsTable;
